/* NESTORA - purchase options box on the product page.

   NO DISCOUNT IS SHOWN UNTIL A CODE HAS ACTUALLY BEEN APPLIED. The box opens
   on the plain price - no strikethrough, no savings badge, and the buy
   button carries the real amount. Generating a code is not applying it; the
   shopper has to put the code in the field and press Apply, the code is
   checked against the discount on the server, and only a `valid: true`
   answer turns the discounted view on. Anything else and the original price
   stays exactly where it is.

   MONEY IS NEVER FORMATTED HERE. Every price string was rendered by Liquid
   into [data-nstcp-map] and this only swaps them in - the same rule the rest
   of nst-pp follows. Formatting money in javascript gets the currency wrong
   the day the store sells anywhere else.

   IT DOES NOT FIGHT nst-pp.js. The box carries `data-pp-form` so the sticky
   bar still has something to watch, but it is a <div>, so the submit handler
   nst-pp.js binds to it can never fire. The buy button carries `data-pp-add`
   so nst-pp.js keeps disabling it when a variant is sold out, and
   deliberately does NOT carry data-pp-add-price, so nst-pp.js leaves this
   button's price alone.

   THE $15 FLOOR IS ENFORCED IN LIQUID AS WELL AS HERE. A variant at or below
   the floor is marked ineligible in the map; this hides the coupon option
   and forces the one-time option.

   "COPIED!" IS ONLY SHOWN WHEN THE COPY ACTUALLY WORKED. clipboard.writeText
   rejects on an insecure origin or a denied permission, so the tick is tied
   to the promise resolving; if every route fails the code is selected
   instead so it can be copied by hand, and nothing claims success.

   EVERY FAILURE IS PRINTED TO THE CONSOLE with the server's own reason
   string, so the browser and `wrangler tail` always agree. A 404 is called
   out by name because it means one specific thing: the App Proxy is not set
   up, so Shopify has nothing registered at /apps/nestora-coupon.

   EVERY localStorage CALL IS WRAPPED. Private mode and blocked site data
   both throw on access, not just on write. */
(function () {
  'use strict';

  var ENDPOINT = '/apps/nestora-coupon';
  var TAG = '[nestora-coupon] ';
  var LS_CODE = 'nstcp_code';
  var LS_APPLIED = 'nstcp_applied';
  var LS_VID = 'nstcp_vid';
  var COPIED_MS = 2000;

  function lsGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }

  function lsSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* ignore */ }
  }

  function visitorId() {
    var id = lsGet(LS_VID);
    if (id) return id;
    var bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    id = Array.prototype.map.call(bytes, function (b) {
      return ('0' + b.toString(16)).slice(-2);
    }).join('');
    lsSet(LS_VID, id);
    return id;
  }

  /* One place that talks to the proxy, so every failure is reported the same
     way and the console always names the real cause. */
  function callApi(path, options) {
    return fetch(ENDPOINT + path, options).then(function (res) {
      return res.text().then(function (text) {
        var body = null;
        try { body = JSON.parse(text); } catch (e) { /* not json */ }

        if (!body) {
          if (res.status === 404) {
            console.error(TAG + path + ' -> HTTP 404. Shopify has nothing registered at ' +
              ENDPOINT + '. The App Proxy has not been set up in the custom app ' +
              '(Configuration -> App proxy: subpath prefix "apps", subpath ' +
              '"nestora-coupon", Proxy URL = the deployed Worker URL).');
          } else {
            console.error(TAG + path + ' -> HTTP ' + res.status +
              ', response was not JSON. First bytes: ' + text.slice(0, 160));
          }
          throw new Error('http_' + res.status);
        }

        if (body.error) {
          console.error(TAG + path + ' -> server said "' + body.error + '"', body);
        }
        return { status: res.status, body: body };
      });
    }, function (netErr) {
      console.error(TAG + path + ' -> network error: ' + (netErr && netErr.message));
      throw netErr;
    });
  }

  function init(box) {
    if (!box || box.dataset.cpReady === '1') return;

    var map;
    try {
      map = JSON.parse(box.querySelector('[data-nstcp-map]').textContent);
    } catch (e) {
      console.error(TAG + 'variant map missing or invalid - box left inert');
      return;
    }
    box.dataset.cpReady = '1';

    var root = box.closest('[data-nstpp]') || document;
    var q = function (sel) { return box.querySelector(sel); };

    var optCoupon = q('[data-nstcp-opt="coupon"]');
    var radios = Array.prototype.slice.call(box.querySelectorAll('[data-nstcp-mode]'));
    var pctEl = q('[data-nstcp-pct]');
    var nowEl = q('[data-nstcp-now]');
    var wasEl = q('[data-nstcp-was]');
    var badgeEl = q('[data-nstcp-badge]');
    var panel = q('[data-nstcp-panel]');
    var genBtn = q('[data-nstcp-gen]');
    var genLabel = q('[data-nstcp-gen-label]');
    var result = q('[data-nstcp-result]');
    var codeEl = q('[data-nstcp-code]');
    var copyBtn = q('[data-nstcp-copy]');
    var copyIco = q('[data-nstcp-copy-ico]');
    var copyOk = q('[data-nstcp-copy-ok]');
    var copyTxt = q('[data-nstcp-copy-txt]');
    var genErr = q('[data-nstcp-err]');
    var input = q('[data-nstcp-input]');
    var applyBtn = q('[data-nstcp-apply]');
    var appliedMsg = q('[data-nstcp-applied]');
    var applyErr = q('[data-nstcp-applyerr]');
    var buyBtn = q('[data-nstcp-buy]');
    var buyPrice = q('[data-nstcp-buyprice]');

    var genLabelText = genLabel ? genLabel.textContent : 'Generate Coupon Code';
    var applyLabelText = applyBtn ? applyBtn.textContent : 'Apply';
    var generating = false;
    var applying = false;
    var copyTimer = null;

    var applied = false;
    var appliedCode = '';

    function variantId() {
      var checked = root.querySelector('[data-pp-variant]:checked');
      if (checked) return String(checked.value);
      var hidden = root.querySelector('[data-pp-id]');
      if (hidden) return String(hidden.value);
      return String(box.getAttribute('data-nstcp-first') || '');
    }

    function data() { return map[variantId()] || null; }

    function mode() {
      var on = box.querySelector('[data-nstcp-mode]:checked');
      return on ? on.value : 'once';
    }

    function setMode(value) {
      radios.forEach(function (r) { r.checked = r.value === value; });
    }

    function render() {
      var d = data();
      if (!d) return;

      /* the cheap-variant rule wins over whatever is selected */
      if (!d.eligible) {
        if (optCoupon) optCoupon.hidden = true;
        if (mode() === 'coupon') setMode('once');
      } else if (optCoupon) {
        optCoupon.hidden = false;
      }

      var onCoupon = d.eligible && mode() === 'coupon';
      /* the only thing that turns the discount on */
      var show = onCoupon && applied;

      if (pctEl) pctEl.textContent = String(d.percent);
      if (nowEl) nowEl.textContent = show ? d.discounted : d.price;
      if (wasEl) {
        wasEl.textContent = d.price;
        wasEl.hidden = !show;
      }
      if (badgeEl) {
        badgeEl.textContent = 'YOU SAVE ' + d.off;
        badgeEl.hidden = !show;
      }
      if (buyPrice) buyPrice.textContent = show ? d.discounted : d.price;
      if (panel) panel.hidden = !onCoupon;
      if (appliedMsg) appliedMsg.hidden = !show;
    }

    function showCode(code) {
      if (codeEl) codeEl.textContent = code;
      if (result) result.hidden = false;
      if (genErr) genErr.hidden = true;
      if (genBtn) genBtn.hidden = true;
    }

    function setGenerating(on) {
      generating = on;
      if (!genBtn) return;
      genBtn.disabled = on;
      if (genLabel) genLabel.textContent = on ? 'Generating…' : genLabelText;
      var spin = genBtn.querySelector('[data-nstcp-spin]');
      if (spin) spin.hidden = !on;
    }

    function setApplying(on) {
      applying = on;
      if (applyBtn) {
        applyBtn.disabled = on;
        applyBtn.textContent = on ? 'Checking…' : applyLabelText;
      }
      if (input) input.disabled = on;
    }

    /* Hand the code to Shopify so it rides along with this session's cart.
       The response is a redirect that sets the discount cookie; we only care
       that it happened. */
    function holdCode(code) {
      return fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        credentials: 'same-origin',
        redirect: 'follow'
      }).catch(function (e) {
        console.error(TAG + 'could not attach the code to the cart: ' + (e && e.message) +
          ' - it can still be typed in at checkout');
      });
    }

    /* ---- restore ---- */
    var savedCode = lsGet(LS_CODE);
    if (savedCode) showCode(savedCode);

    var savedApplied = lsGet(LS_APPLIED);
    if (savedApplied) {
      applied = true;
      appliedCode = savedApplied;
      /* the cart cookie may have lapsed since - put it back quietly */
      holdCode(savedApplied);
    }

    /* ---- generate ---- */
    if (genBtn) {
      genBtn.addEventListener('click', function () {
        if (generating) return;

        var already = lsGet(LS_CODE);
        if (already) { showCode(already); return; }

        setGenerating(true);
        if (genErr) genErr.hidden = true;

        callApi('?vid=' + encodeURIComponent(visitorId()), {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        })
          .then(function (r) {
            if (!r.body || !r.body.code) throw new Error(r.body && r.body.error || 'no_code');
            lsSet(LS_CODE, r.body.code);
            showCode(r.body.code);
          })
          .catch(function () {
            if (genErr) genErr.hidden = false;
          })
          .then(function () { setGenerating(false); });
      });
    }

    /* ---- apply ---- */
    function doApply() {
      if (applying) return;

      var typed = (input ? input.value : '') || '';
      var code = typed.trim().toUpperCase();   /* case and spaces do not matter */

      if (appliedMsg) appliedMsg.hidden = true;
      if (applyErr) applyErr.hidden = true;

      if (!code) {
        if (applyErr) applyErr.hidden = false;
        return;
      }

      setApplying(true);

      callApi('/validate?code=' + encodeURIComponent(code), {
        method: 'GET',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (r) {
          if (!r.body || r.body.valid !== true) {
            console.error(TAG + 'code rejected: ' + ((r.body && r.body.reason) || 'unknown'));
            throw new Error('invalid');
          }
          var good = r.body.code || code;
          return holdCode(good).then(function () {
            applied = true;
            appliedCode = good;
            lsSet(LS_APPLIED, good);
            render();
          });
        })
        .catch(function () {
          applied = false;
          if (applyErr) applyErr.hidden = false;
          render();
        })
        .then(function () { setApplying(false); });
    }

    if (applyBtn) applyBtn.addEventListener('click', doApply);
    if (input) {
      input.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter') { ev.preventDefault(); doApply(); }
      });
    }

    /* ---- copy ---- */
    function flashCopied() {
      window.clearTimeout(copyTimer);
      if (copyBtn) copyBtn.classList.add('is-done');
      if (copyIco) copyIco.hidden = true;
      if (copyOk) copyOk.hidden = false;
      if (copyTxt) copyTxt.hidden = false;

      copyTimer = window.setTimeout(function () {
        if (copyBtn) copyBtn.classList.remove('is-done');
        if (copyIco) copyIco.hidden = false;
        if (copyOk) copyOk.hidden = true;
        if (copyTxt) copyTxt.hidden = true;
      }, COPIED_MS);
    }

    /* last resort when the clipboard API is unavailable or refused: put the
       code under the caret so a manual copy is one keystroke away */
    function selectCode() {
      if (!codeEl || !window.getSelection) return;
      try {
        var range = document.createRange();
        range.selectNodeContents(codeEl);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } catch (e) { /* nothing more we can do */ }
    }

    if (copyBtn && codeEl) {
      copyBtn.addEventListener('click', function () {
        var text = codeEl.textContent.trim();
        if (!text) return;

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(flashCopied, function (err) {
            console.error(TAG + 'clipboard refused: ' + (err && err.message) +
              ' - the code has been selected instead');
            selectCode();
          });
        } else {
          console.error(TAG + 'no clipboard API on this browser - the code has been selected instead');
          selectCode();
        }
      });
    }

    radios.forEach(function (r) { r.addEventListener('change', render); });

    /* nst-pp.js listens for the same event; reading the checked radio rather
       than the hidden input means the order the two handlers run in does not
       matter. */
    Array.prototype.forEach.call(
      root.querySelectorAll('[data-pp-variant]'),
      function (el) { el.addEventListener('change', render); }
    );

    /* ---- buy now: add, then straight to checkout ---- */
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        if (buyBtn.disabled) return;
        var qtyInput = root.querySelector('[data-pp-qtyinput]');
        var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        if (!quantity || quantity < 1) quantity = 1;

        buyBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId(), quantity: quantity }] })
        })
          .then(function (r) { return r.json(); })
          .then(function (state) {
            if (state && state.status) throw new Error('cart_error');
            window.location.href = '/checkout';
          })
          .catch(function (e) {
            console.error(TAG + 'add to cart failed: ' + (e && e.message));
            buyBtn.disabled = false;
            window.location.href = '/cart';
          });
      });
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[data-nstcp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-nstcp]').forEach(function (el) { el.dataset.cpReady = ''; });
    boot();
  });
})();
